import { render } from "./TheMaskSpan.vue?vue&type=template&id=2ac55a1a"
import script from "./TheMaskSpan.vue?vue&type=script&lang=js"
export * from "./TheMaskSpan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__